import * as THREE from 'three'
import { Raycaster } from 'three'
import Experience from '../Experience.js'
import { MeshStandardMaterial } from 'three'
import { DragControls } from 'three/addons/controls/DragControls.js';
import { modeldata } from '../../motion-industries'
import { SUBTRACTION, INTERSECTION, ADDITION, Brush, Evaluator } from 'three-bvh-csg';
import ThreeBSP from 'three-csg';

export default class Functions {
    constructor(hoverEnabled, clickEnabled) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        this.resources = this.experience.resources
        this.resource = this.resources.items.object
        this.sizes = this.experience.sizes
        this.camera = this.experience.camera
        this.canvas = this.experience.canvas
        this.renderer = this.experience.renderer
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('fox')
        }
        this.raycaster = new Raycaster()
        this.rayOrigin = new THREE.Vector3(0, 0, 0)
        this.rayDirection = new THREE.Vector3(0, 0, 0)
        this.rayDirection.normalize()
        this.raycaster.set(this.rayOrigin, this.rayDirection)
        this.intersectedObjects = []
        this.modeldata = modeldata['conway-machines']
        this.mouse = new THREE.Vector2()
        window.addEventListener('mousemove', (event) => {
            this.mouse.x = event.clientX / this.sizes.width * 2 - 1
            this.mouse.y = - (event.clientY / this.sizes.height) * 2 + 1

        })

        function adjustClass() {
            // var element = document.getElementById("mySidebar");
            if (window.innerWidth < 720) {
                element.classList.remove("sidebar");
                element.classList.add("sidebarMobile");
            } else {
                element.classList.remove("sidebarMobile");
                element.classList.add("sidebar");
            }
        }
        this.dragging = false
        this.clone = null
        this.haha = false
        this.offset = new THREE.Vector3()


        
        // document.getElementById("drag-button-1").addEventListener("mousedown", (event) => {
        //     this.makeShape(0, 0, 200, 200, 32, 15, "https://viewer-dev.zipcpq.com/models/ConwayMachine/OSC_0404.svg", 1, 1)
        //     this.addShape()
        //     this.haha = true
        //     this.placeholder.position.set(-4,-0.5,-3)

        //     this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        //     this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        //     this.raycaster.setFromCamera(this.mouse, this.camera.instance)
        //     this.intersect = this.raycaster.intersectObjects(this.scene.children)
        //     console.log(this.intersect);
        //     if (this.intersect.length > 0) {
        //        this.clone = this.mesh.clone()
        //         const intersectionPoint = this.intersect[0].point;

        //         const targetX = intersectionPoint.x 
        //         const targetZ = intersectionPoint.z 

        //         // Set the position of the clone with the calculated offset.
        //         this.clone.position.x = intersectionPoint.x
        //         this.clone.position.z = intersectionPoint.z-1.3
        //         this.scene.add(this.clone)


        //     }

        // })



        // document.getElementById("drag-button-2").addEventListener("mousedown", (event) => {
        //     this.makeShape(0, 0, 100, 200, 32, 15, "https://viewer-dev.zipcpq.com/models/ConwayMachine/TERM_02044.svg", 2, 1)
        //     this.addShape()
        //     this.haha = true

        //     this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        //     this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        //     this.raycaster.setFromCamera(this.mouse, this.camera.instance)
        //     this.intersect = this.raycaster.intersectObjects(this.scene.children)
        //     console.log(this.intersect);
        //     this.placeholder.position.set(0,-0.5,-3)

        //     if (this.intersect.length > 0) {
        //         this.clone = this.mesh.clone()
        //         const intersectionPoint = this.intersect[0].point;

        //         const targetX = intersectionPoint.x - this.offset.x;
        //         const targetZ = intersectionPoint.z - this.offset.z;

        //         // Set the position of the clone with the calculated offset.
        //         this.clone.position.x += (targetX - this.clone.position.x) * 0.1;
        //         this.clone.position.z += (targetZ - this.clone.position.z) * 0.1;
        //         this.scene.add(this.clone)
        //         console.log(this.clone.position);

        //     }

        // })
        // document.getElementById("drag-button-3").addEventListener("mousedown", (event) => {
        //     this.makeShape(0, 0, 300, 200, 32, 15, "https://viewer-dev.zipcpq.com/models/ConwayMachine/Divider_0604.svg", 1, 1.5)
        //     this.addShape()
        //     this.haha = true
        //     this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        //     this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        //     this.raycaster.setFromCamera(this.mouse, this.camera.instance)
        //     this.intersect = this.raycaster.intersectObjects(this.scene.children)
        //     console.log(this.intersect);
        //     if (this.intersect.length > 0) {
        //         this.clone = this.mesh.clone()
        //         const intersectionPoint = this.intersect[0].point;

        //         const targetX = intersectionPoint.x - this.offset.x;
        //         const targetZ = intersectionPoint.z - this.offset.z;

        //         // Set the position of the clone with the calculated offset.
        //         this.clone.position.x += (targetX - this.clone.position.x) * 0.1;
        //         this.clone.position.z += (targetZ - this.clone.position.z) * 0.1;
        //         this.scene.add(this.clone)
        //         console.log(this.clone.position);
        //         this.placeholder.position.set(4,-0.5,-3)

        //     }


        // })
        //     window.addEventListener("mousemove", (event) => {
        //         this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        //         this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        //         this.raycaster.setFromCamera(this.mouse, this.camera.instance)
        //         this.intersects = this.raycaster.intersectObjects(this.scene.children)
        //         if (this.haha == true && this.clone) {
        //             if (this.intersects.length > 0) {

        //                 console.log("dada");
        //                 const intersectionPoint = this.intersects[0].point;
        //                 const targetX = intersectionPoint.x 
        //                 const targetZ = intersectionPoint.z 
        //                 this.clone.position.x += (targetX - this.clone.position.x) * 0.1;
        //                 this.clone.position.z += (targetZ - this.clone.position.z) * 0.1;



        //             }
        //         }
        //     })
        //     console.log(this.scene.children);
        //     window.addEventListener("mousemove",(event)=>{
        //         this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        //         this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        //         this.raycaster.setFromCamera(this.mouse, this.camera.instance)
        //         if(this.placeholder){
        //         this.intersects = this.raycaster.intersectObject(this.placeholder, true);
        //     if(this.intersects[0] && this.clone && this.haha){
        //         this.clone.position.copy(this.placeholder.position)
        //         this.placeholder.visible=true
        //     }
        // }
        //     })

        //     window.addEventListener("mouseup", (event) => {
        //         this.haha = false
        //         this.placeholder.visible=false


        //     })



    }

    makeShape(null1, null2, shapeWidth, shapeHeight, radius, holeRadiuss, textured, scaleX, scaleY) {
        this.extrudeSettings = { depth: 1, bevelEnabled: true, bevelSegments: 1, steps: 1, bevelSize: 0.01, bevelThickness: 0.01 }

        function createRoundedRectShape(x, y, width, height, radius, holeRadius) {
            const shape = new THREE.Shape();

            shape.moveTo(x, y + radius);
            shape.lineTo(x, y + height - radius);
            shape.quadraticCurveTo(x, y + height, x + radius, y + height);
            shape.lineTo(x + width - radius, y + height);
            shape.quadraticCurveTo(x + width, y + height, x + width, y + height - radius);
            shape.lineTo(x + width, y + radius);
            shape.quadraticCurveTo(x + width, y, x + width - radius, y);
            shape.lineTo(x + radius, y);
            shape.quadraticCurveTo(x, y, x, y + radius);

            const holeShape1 = new THREE.Shape();
            holeShape1.absarc(holeRadius + 10, holeRadius + 10, holeRadius, 0, Math.PI * 2, false);

            const holeShape2 = new THREE.Shape();
            holeShape2.absarc(width - (holeRadius + 10), holeRadius + 10, holeRadius, 0, Math.PI * 2, false);

            const holeShape3 = new THREE.Shape();
            holeShape3.absarc(width - (holeRadius + 10), height - (holeRadius + 10), holeRadius, 0, Math.PI * 2, false);

            const holeShape4 = new THREE.Shape();
            holeShape4.absarc(holeRadius + 10, height - (holeRadius + 10), holeRadius, 0, Math.PI * 2, false);

            shape.holes = [holeShape1, holeShape2, holeShape3, holeShape4];

            return shape;
        }
        this.roundedRectShape = createRoundedRectShape(null1, null2, shapeWidth, shapeHeight, radius, holeRadiuss);

        var settings = {
            amount: 2,
            steps: 1,
            bevelEnabled: false,
            curveSegments: 24
        };

        this.geometry = new THREE.CylinderGeometry(100, 100, 150, 8, 1, false, 0, Math.PI);
        // this.geometry = new THREE.ExtrudeGeometry(this.roundedRectShape, this.extrudeSettings);
        console.log(this.geometry.attributes.uv);
        this.geometry.attributes.uv.normalized = true

        this.placeMaterial = new THREE.MeshBasicMaterial({ color: 0x00FF00, transparent: true, opacity: 0.7 });
        this.placeholder = new THREE.Mesh(this.geometry.clone(), this.placeMaterial)
        this.placeholder.rotation.set(Math.PI / 2, 0, 0)
        this.placeholder.scale.set(0.01, 0.01, 0.01);
        this.grouper = new THREE.Group()
        this.grouper.add(this.placeholder)
        this.scene.add(this.placeholder, this.grouper)
        this.placeholder.visible = false
        this.texture = new THREE.TextureLoader().load(textured);
        this.material = new THREE.MeshBasicMaterial({ map: this.texture, });
        this.texture.colorSpace = THREE.SRGBColorSpace;

        this.texture.wrapS = this.texture.wrapT = THREE.RepeatWrapping;
        this.texture.generateMipmaps = true;
        this.texture.minFilter = THREE.LinearMipmapLinearFilter;
        this.texture.anisotropy = 16
        const uvAttribute = this.geometry.attributes.uv;
        // Adjust this value as needed
        const minU = Math.min(...uvAttribute.array);
        const maxU = Math.max(...uvAttribute.array);
        const minV = Math.min(...uvAttribute.array.slice(1)); // Skip the first value (since it's 'v')
        const maxV = Math.max(...uvAttribute.array.slice(1));
        for (let i = 0; i < uvAttribute.array.length; i += 2) {
            uvAttribute.array[i] = ((uvAttribute.array[i] - minU) / (maxU - minU)) * scaleX; // Horizontal flip
            uvAttribute.array[i + 1] = 1 - ((uvAttribute.array[i + 1] - minV) / (maxV - minV)) * scaleY; // Vertical flip
        }
        this.mesh = new THREE.Mesh(this.geometry, this.material);
        this.mesh.rotation.set(Math.PI / 2, 0, 0);
        this.mesh.scale.set(0.01, 0.01, 0.01);
        console.log(this.mesh);

    }

    addShape() {
        let group, group1;
        this.group = new THREE.Group();
        // this.scene.add(this.group)
        group1 = new THREE.Group();
        var objectFor

        const vectorPosition = new THREE.Vector3(0, 0, 0);
        const otherObjectGeometry = new THREE.SphereGeometry(0.05, 32, 32);
        const otherObjectMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000 });
        const otherObject = new THREE.Mesh(otherObjectGeometry, otherObjectMaterial);
        otherObject.position.set(2, 0, 0);
        const otherObjectPosition = new THREE.Vector3(2, 0, 0);

        let objects = []

        // Example usage:
        const holeRadius = 8; // Adjust this as needed

        var boundingBox = new THREE.Box3().setFromObject(this.mesh);

        var min = boundingBox.min; // Minimum coordinates of the bounding box
        var max = boundingBox.max; // Maximum coordinates of the bounding box

        var middlex = (boundingBox.max.x + boundingBox.min.x) / 2;
        var middley = (boundingBox.max.y + boundingBox.min.y) / 2;
        var middlez = (boundingBox.max.z + boundingBox.min.z) / 2;

        objectFor = new THREE.Mesh(otherObjectGeometry, otherObjectMaterial);
        objectFor.position.set(middlex, middley, min.z)
        // this.scene.add(objectFor)
        this.group.add(this.mesh);

        objects.push(this.group);
        this.group.userData.isGroup = true

        this.scene.traverse(function (object) {
            if (object instanceof THREE.Vector3) {
                console.log("distevectori");
                console.log(object);
            }
        });
        const object2Position = new THREE.Vector3(0, 1, 0);
        const holeSize = 1; // Adjust the size of the holes as needed

        // objectFor.position.set(0,0,2)

        let dragOffset = null;
        let isDragging = false;
        let draggedObject = null;

        // Store the initial mouse position
        const initialMousePosition = new THREE.Vector2();

        // Store the initial object position
        // Add a mouse down event listener to start dragging
        const raycaster = new THREE.Raycaster();
        const mouse = new THREE.Vector2();
        let offset = new THREE.Vector3();
        let selectedObject = null;
        let initialPosition = new THREE.Vector3();
        let selectedGroup = null;
        // Define the step size
        const stepSize = 0.1;
        let initialMouseX = 0;
        let initialMouseZ = 0;
        let initialObjectPosition = new Map()


        var mousedown = false

        window.addEventListener('mousedown', (event) => {
            // Calculate mouse position in normalized device coordinates (-1 to +1)
            // Cast a ray from the camera through the mouse position
            mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

            // Perform raycasting to find objects at the clicked position
            raycaster.setFromCamera(this.mouse, this.camera.instance); // 'camera' should be your camera object
            const intersects = raycaster.intersectObjects(objects); // 'objects' should be an array of your 3D objects

            if (intersects.length > 0) {
                const selected = intersects[0].object;
                if (selected.parent && selected.parent.userData && selected.parent.userData.isGroup) {
                    console.log("ddddd");
                    selectedGroup = selected.parent;
                    offset.copy(intersects[0].point).sub(selectedGroup.position);
                    document.body.style.cursor = 'move';
                }

                // Store the initial position// Store the initial position
            }
        });

        // Add a mouse up event listener to stop dragging
        window.addEventListener('mouseup', () => {
            selectedGroup = null;
            document.body.style.cursor = 'auto';

        });
        const axisHelper = new THREE.AxesHelper(10); // 10 is the size of the axis helper

        let selectedObject1 = null; // Store the selected object

        window.addEventListener('mousemove', (event) => {

            if (selectedGroup) {
                // Update the selected object's position based on mouse movement
                mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
                mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
                raycaster.setFromCamera(this.mouse, this.camera.instance);

                const intersects = raycaster.intersectObjects(objects); // 'objects' should be an array of your 3D objects

                if (intersects.length > 0) {
                    const intersectionPoint = intersects[0].point;
                    const newX = Math.round((intersectionPoint.x - offset.x) / stepSize) * stepSize;
                    const newZ = Math.round((intersectionPoint.z - offset.z) / stepSize) * stepSize;

                    selectedGroup.position.x = newX;
                    selectedGroup.position.z = newZ;

                    // Check for connections between the selected object and other objects
                    const thresholdDistance = 0.56; // Adjust this distance threshold as needed
                    const distance = vectorPosition.distanceTo(otherObjectPosition);
                    console.log(distance);
                    objectFor.updateMatrixWorld();
                    console.log(objectFor.position);
                    var distance1 = objectFor.position.distanceTo(otherObject.position);

                    // Calculate the sum of the radii of the spheres
                    var radiusSum = objectFor.geometry.radius + otherObject.geometry.radius;

                    // Check if the distance between the centers is less than or equal to the sum of the radii
                    if (distance1 <= radiusSum) {
                        // The spheres touch or intersect
                        console.log("Spheres touch or intersect.");
                    } else {
                        // The spheres do not touch or intersect
                        console.log("Spheres do not touch or intersect.");
                    }
                    if (distance < thresholdDistance) {
                        vectorPosition.copy(objectFor.position)

                        // Establish a connection between the selected object and the target object
                        console.log(`Connected ${selectedGroup.name} to ${object.name}`);
                        // You can perform further actions here, such as adding a line or updating data
                    }
                }
            }
        });
    }
}